import React from "react";
import { CircleArrowRight } from "lucide-react";
import herobg from "../../images/LandingPageImage/hero-bg.webp";
import group9 from "../../images/LandingPageImage/home_section.webp";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
    const navigate = useNavigate();

  return (
    <div className="bg-brand-light font-inter overflow-hidden">
      <section
        className="relative flex flex-col items-center bg-cover bg-center bg-no-repeat px-4 pt-8 sm:px-5 sm:pt-10 md:px-12 md:pt-12 lg:px-20 lg:pt-16 xl:px-20 xl:pt-16"
        style={{
          backgroundImage: `url(${herobg})`,
          color: "var(--color-text-main)",
        }}
      >
        <div className="flex flex-col items-center justify-center  text-center">
          <div className=" w-full lg:w-[70%] xl:w-[55%]">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
              <span className="text-brand-primary">
                Empower Your Business with{" "}
              </span>
              <span className="text-brand-dark">Seamless Marketing Tools!</span>
            </h1>
          </div>

          <div className="pt-4 pb-1 text-lg md:text-xl w-full lg:w-[70%] xl:w-[45%] text-slate-600">
            Discover innovative solutions to maximize the potential of your
            WhatsApp and SMS marketing campaigns.
          </div>

          <div className="pt-6">
            <button 
               onClick={() => navigate("/login")}
            className="bg-brand-primary text-white py-2 px-6 rounded-md flex gap-2 items-center justify-center hover:brightness-110 transition-all shadow-md active:scale-95">
              Get Started
              <CircleArrowRight size={20} />
            </button>
          </div>
        </div>

        <div className="mt-8 flex justify-center items-end w-full">
          <img
            loading="lazy"
            src={group9}
            className="h-auto object-contain w-full md:w-[95%] lg:w-[85%] xl:w-[70%] block mb-0 align-bottom"
            alt="Isancharr enhances customer trust"
          />
        </div>
      </section>
    </div>
  );
}
